export default {"src":"/_next/static/media/location-icon.b006c7cf.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};